// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  name: 'develop',
  apiUrl: 'https://dev-backend.1life2connect.com',
  // apiUrl: 'http://localhost:8888',
  google: {
    apiKey: 'AIzaSyBimXu0GYbRugYC_YMe0099aOESNWBUD9U',
  },
  googleAnalyticsId: 'G-FP1WS899RG',
  version: `${require('../../package.json').version}`,
  projectName: require('../../package.json').name,
  paypalDonateUrl: 'https://www.sandbox.paypal.com/donate/?hosted_button_id=MN5EB7ET3ZAA6',
  sessionActivityTimerDelayMs: 60 * 60 * 1000, // 1 hour in milliseconds
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
